import { render, staticRenderFns } from "./leadsCostManager.vue?vue&type=template&id=c6bcb9da&scoped=true"
import script from "./leadsCostManager.vue?vue&type=script&lang=js"
export * from "./leadsCostManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6bcb9da",
  null
  
)

export default component.exports